import { WebshopCategory } from '@cldsystems/ws-api-client';
import { ERRORS } from '@/constants/error';
import { useAppContext } from '@/providers/app-provider/app-provider';
import { List } from '@/types/common';

export const useCategoriesContext = () => {
  const context = useAppContext<{ categories: List<WebshopCategory> }>();
  if (!context.categories) {
    throw ERRORS.REGULAR('useCategories must be passed to <Page/> context');
  }
  return context.categories;
};
